import Vue from 'vue'
import Vuex from 'vuex'
import devs from './modules/devs'
// import zones from './modules/zones'
import buildings from './modules/buildings'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

import {
    USER_SET,
    USER_LOGGED,
    MQTT_USER_SET,
    MQTT_CONNECTED_SET,
    DEVS_SET, BUILDINGS_SET,
    CTRL_FAIL_SNACKBAR,
    BUILDING_SET_SELECTED,
    SHOW_LEFT_MENU,
} from './muations'
import userApi from '../api/user'

export default new Vuex.Store({
    modules: {
        devs,
        // zones,
        buildings,
    },
    state: {
        user: { },
        loggedIn: false,
        mqttUser: { },
        mqttConnected: false,
        ctrlFailSnackbar: false,
        showMenu: false,
    },

    mutations:{
        [USER_SET](state, payload){
            state.user = payload
        },
        [USER_LOGGED](state, payload){
            state.loggedIn = payload
        },
        [MQTT_CONNECTED_SET](state, payload){
            state.mqttConnected = payload
        },
        [MQTT_USER_SET](state, payload){
            state.mqttUser = payload
        },
        [CTRL_FAIL_SNACKBAR](state, payload){
            state.ctrlFailSnackbar = payload
        },
        [SHOW_LEFT_MENU](state, payload){
            state.showMenu = payload
        },
    },

    getters:{

    },

    actions:{
        getAuthUser({commit}){
            return userApi.getCurrentUser((userData)=>{
                commit(USER_LOGGED, true)
                commit(USER_SET, userData)
            }, ()=>{
                commit(USER_LOGGED, false)
            })
        },

        logout({commit}){
            userApi.logout((data)=>{
                if(data.done){
                    commit(USER_LOGGED, false)
                    commit(USER_SET, {})
                    // сессия обнуляется и новый CSRF токен не выдается до перезагрузки страницы. Приходится перезагружать все.
                    window.location.reload();
                }
            }, (req)=>{
                console.error(req)
            })
        },

        loadUserData({commit}){
            return userApi.getFullData((data)=>{
                // commit('devs/'+DEVS_SET, data.devices)
                commit(DEVS_SET, data.devices)
                commit(BUILDINGS_SET, data.buildings)
                commit(MQTT_USER_SET, data.mqtt_user)
                commit(BUILDING_SET_SELECTED, data.default_building_id)
            }, (req)=>{
                console.error(req)
            })
        },

        showCtrlFailAlert({commit}){
            commit(CTRL_FAIL_SNACKBAR, true)
        },
        hideCtrlFailAlert({commit}){
            commit(CTRL_FAIL_SNACKBAR, false)
        },

        showLeftMenu({commit}){
            commit(SHOW_LEFT_MENU, true)
        },
        hideLeftMenu({commit}){
            commit(SHOW_LEFT_MENU, false)
        },
    },

    strict: debug,
})
